import { getState } from "../store";
import axios from "../config/axios-config"; 

const addCommonHeaders = (headers) => {
  return {
    ...headers,
    authorization: `Bearer ${getState().auth.user.data.access_token}`,
  };
};

export const POST = (url, data, headers) =>
  axios({
    method: "POST",
    url: url,
    headers: addCommonHeaders(headers),
    data: data,
  }).then((res) => res.data);

export const GET = (url, data, headers) =>
  axios
    .get(url, {
      headers: addCommonHeaders(headers),
      params: data,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.keys(params || {}).forEach((key) => {
          const val = params[key];
          if (val === null || typeof val === "undefined") return;
          if (Array.isArray(val)) {
            val.forEach((v) => {
              if (v !== null && typeof v !== "undefined" && v !== "") {
                searchParams.append(key, v);
              }
            });
          } else {
            searchParams.append(key, val);
          }
        });
        return searchParams.toString();
      },
    })
    .then((res) => res.data);
